import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';
import { ROUTES } from '@/constants/routes';

export function AdminGuard() {
    const getUser = useAuthStore((s) => s.getUser);
    const user = getUser();

    if (!user?.is_staff) {
        return <Navigate to={ROUTES.home} replace />;
    }

    return <Outlet />;
}
